export default {
  methods: {
    closeUpgradeModal() {
      this.$store.commit('userSubscriptions/setOpenUpgradeModal', false)
    }
  }
}
